/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_AprilInputs */

const he_month_april = /** @type {(inputs: Month_AprilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אפריל`)
};

const en_month_april = /** @type {(inputs: Month_AprilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April`)
};

/**
* | output |
* | --- |
* | "April" |
*
* @param {Month_AprilInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_april = /** @type {((inputs?: Month_AprilInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_AprilInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_april(inputs)
	return en_month_april(inputs)
});